// Garden defaults
export const DEFAULT_GARDEN_WIDTH_CM = 400;
export const DEFAULT_GARDEN_HEIGHT_CM = 300;
export const GRID_CELL_CM = 25;

// Plans & pricing
//
// Declarative only. Nothing in the application enforces these limits today and
// no purchase path is exposed anywhere in the interface — the CGU say as much.
// The pricing page reads this object so that the price a visitor is quoted and
// the price Stripe would charge cannot drift apart once checkout does open.
export const PREMIUM_OPEN = false;

export const PLANS = {
  free: {
    name: "Gratuit",
    price_monthly: 0,
    price_yearly: 0,
  },
  premium: {
    name: "Premium",
    price_monthly: 4.9,
    price_yearly: 39,
    /** Matches the `trial_period_days` set in the Stripe checkout session. */
    trial_days: 14,
  },
} as const;

// Photo upload
export const PHOTO_MAX_SIZE_MB = 10;
export const PHOTO_MAX_DIMENSION = 1200;
export const PHOTO_QUALITY = 0.8;

// Cache
export const WEATHER_CACHE_HOURS = 1;

// Share link
export const SHARE_LINK_VALIDITY_DAYS = 90;
